import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { CheckCircle2, Shield, Eye } from "lucide-react";
import { Button } from "../ui/button";

export function SuccessStep({ voteResult, onReset, isPreview }) {
  const { t } = useTranslation();

  return (
    <motion.div key="step4" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-white border border-slate-200 rounded-xl p-8 text-center">
      {isPreview && (
        <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-center justify-center gap-2">
          <Eye className="h-4 w-4 text-amber-600" />
          <p className="text-sm text-amber-800 font-medium">{t("voting2.previewMode")}</p>
        </div>
      )}
      <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <CheckCircle2 className="h-10 w-10 text-emerald-600" />
      </div>
      <h3 className="text-2xl font-heading font-bold text-slate-900 mb-2">{t('voting.voteRegistered')}</h3>
      <p className="text-slate-600 mb-6">{t('voting.voteRegisteredDesc')}</p>
      {!isPreview && voteResult.public_id && (
        <div className="bg-slate-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-slate-500 mb-1">{t('voting.publicVoteId')}</p>
          <p className="font-mono text-lg text-slate-900 font-bold">{voteResult.public_id}</p>
        </div>
      )}
      <div className="flex items-center justify-center gap-2 text-sm text-slate-500">
        <Shield className="h-4 w-4" /><span>{t('voting.voteEncrypted')}</span>
      </div>
      <Button onClick={onReset} className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 text-base" data-testid="back-to-identify-btn">
        {t('voting.goBack')}
      </Button>
    </motion.div>
  );
}
